import { render, staticRenderFns } from "./RouterOutputItem.vue?vue&type=template&id=f16596dc&scoped=true"
import script from "./RouterOutputItem.vue?vue&type=script&lang=js"
export * from "./RouterOutputItem.vue?vue&type=script&lang=js"
import style0 from "./RouterOutputItem.vue?vue&type=style&index=0&id=f16596dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16596dc",
  null
  
)

export default component.exports